// src/components/AppsManagement.js
import React, { useEffect, useState } from 'react';
import {
  Container,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Button,
  TextField,
  Alert,
  TableContainer
} from '@mui/material';
import { getApps, addApp, updateApp, deleteApp } from '../services/api';

const AppsManagement = ({ token }) => {
  const [apps, setApps] = useState([]);
  const [newApp, setNewApp] = useState({ app_name: '', description: '' });
  const [editingApp, setEditingApp] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => { fetchApps(); }, []);

  const fetchApps = async () => {
    try {
      const data = await getApps(token);
      setApps(data);
    } catch {
      setError('Erro ao buscar apps');
    }
  };

  const handleAddApp = async () => {
    if (!newApp.app_name) { setError('Nome é obrigatório'); return; }
    try {
      await addApp(token, newApp);
      setNewApp({ app_name: '', description: '' });
      fetchApps();
    } catch {
      setError('Erro ao adicionar app');
    }
  };

  const handleUpdateApp = async () => {
    if (!editingApp) return;
    try {
      await updateApp(token, editingApp.id, {
        app_name: editingApp.app_name,
        description: editingApp.description,
        is_enabled: editingApp.is_enabled
      });
      setEditingApp(null);
      fetchApps();
    } catch {
      setError('Erro ao atualizar app');
    }
  };

  const handleDeleteApp = async (id) => {
    try {
      await deleteApp(token, id);
      fetchApps();
    } catch {
      setError('Erro ao desabilitar app');
    }
  };

  return (
    <Container sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>📱 Gerenciamento de Apps</Typography>
      {error && <Alert severity="error">{error}</Alert>}

      <Paper sx={{ p: 2, mb: 3 }}>
        <Typography variant="h6">Novo App</Typography>
        <TextField
          label="Nome"
          fullWidth margin="normal"
          value={newApp.app_name}
          onChange={e => setNewApp({ ...newApp, app_name: e.target.value })}
        />
        <TextField
          label="Descrição"
          fullWidth margin="normal"
          value={newApp.description}
          onChange={e => setNewApp({ ...newApp, description: e.target.value })}
        />
        <Button variant="contained" onClick={handleAddApp}>Adicionar App</Button>
      </Paper>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Nome</TableCell>
              <TableCell>Descrição</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {apps.map(app => (
              <TableRow key={app.id}>
                <TableCell>
                  {editingApp?.id === app.id
                    ? <TextField
                        fullWidth
                        value={editingApp.app_name}
                        onChange={e => setEditingApp({ ...editingApp, app_name: e.target.value })}
                      />
                    : app.app_name
                  }
                </TableCell>
                <TableCell>
                  {editingApp?.id === app.id
                    ? <TextField
                        fullWidth
                        value={editingApp.description}
                        onChange={e => setEditingApp({ ...editingApp, description: e.target.value })}
                      />
                    : app.description
                  }
                </TableCell>
                <TableCell>{app.is_enabled ? 'Ativo' : 'Inativo'}</TableCell>
                <TableCell>
                  {editingApp?.id === app.id
                    ? (
                      <>
                        <Button onClick={handleUpdateApp}>Salvar</Button>
                        <Button onClick={() => setEditingApp(null)}>Cancelar</Button>
                      </>
                    ) : (
                      <>
                        <Button onClick={() => setEditingApp(app)}>Editar</Button>
                        <Button color="error" onClick={() => handleDeleteApp(app.id)}>
                          {app.is_enabled ? 'Desabilitar' : 'Habilitar'}
                        </Button>
                      </>
                    )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default AppsManagement;
